import purchaseHistory from './purchaseHistory'
export const purchaseHistoryService = purchaseHistory

